<template>
  <div class="form-group required">
    <label class="control-label">Correct Option</label>
    <div class="form-group">
      <el-select
        v-model="correct_option"
        v-validate="'required'"
        name="correct_option"
        placeholder="select correct option"
        style="width: 100%"
      >
        <el-option
          v-for="item in [
            { value: 'true', label: 'True' },
            { value: 'false', label: 'False' },
          ]"
          :key="item.value"
          v-bind:class="{ 'has-error': errors.has('correct_option') }"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div class="help text-danger" v-show="errors.has('correct_option')">
        {{ errors.first("correct_option") }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TrueFalse",
  props: ["id"],
  data: () => ({
    correct_option: "",
  }),
  updated() {
    this.$emit("updateTrueFalseAns", this.id, this.correct_option);
  },
};
</script>
